import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { BUY_TOUCHLESS, TALK_TO_SALES } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import PurchaseMotionButtonWrapper from '../../../components/common/purchaseMotions/PurchaseMotionButtonWrapper';
import HighlightedMerchPriceDisplay from '../../../components/merch-card/price-display/HighlightedMerchPriceDisplay';
import { useSkuAdditionalUnits } from '../../../components/merch-card/useSkuAdditionalUnits';
import { APP } from '../../../constants/tracking/App';
import { UPGRADE_PAGES } from '../../../constants/tracking/Locations';
import { usePricingInfoFromProductConfigurations, useProductConfigurationsFromProductLineAndLevel } from '../../../hooks/upgradePageHooks';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrialUpgradePageMerchCard = ({
  apiName,
  productLine
}) => {
  const productLevel = getProductLevelFromApiNameString(apiName);
  const productConfigurations = useProductConfigurationsFromProductLineAndLevel({
    productLine,
    productLevel
  });
  const upgradeData = {
    apiName,
    app: APP,
    screen: UPGRADE_PAGES.TRIAL,
    uniqueId: `${UPGRADE_PAGES.TRIAL}-${ApiNameToUpgradeProductMap[apiName]}`,
    upgradeProduct: ApiNameToUpgradeProductMap[apiName]
  };
  const pricingInfo = usePricingInfoFromProductConfigurations(productConfigurations);
  const {
    offerInfo
  } = pricingInfo;
  const currencyCode = useAppSelector(activeCurrencySelector);
  const term = offerInfo && offerInfo.payment || MONTHLY;
  const {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    skuId
  } = useSkuAdditionalUnits({
    productLine,
    productLevel
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HighlightedMerchPriceDisplay, {
      skuId: skuId,
      useLargePrice: false,
      queryParamTerm: term,
      quantityPackSkuId: isAdditionalUnitSkuIdAQuantityPack && additionalUnitSkuId ? additionalUnitSkuId : undefined,
      quantityPackQuantity: isAdditionalUnitSkuIdAQuantityPack ? additionalUnitQuantity : 0
    }), /*#__PURE__*/_jsxs(UIButtonWrapper, {
      style: {
        maxWidth: 350
      },
      className: "m-top-4",
      children: [/*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
        currencyCode: currencyCode,
        level: 1,
        productConfigurations: productConfigurations,
        location: UPGRADE_PAGE,
        purchaseMotions: [BUY_TOUCHLESS],
        trackingSource: "HC0119-HeroBanner",
        upgradeData: upgradeData,
        use: "primary",
        style: {
          height: 40,
          width: 315
        },
        queryParamTerm: "annual"
      }), /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
        level: 1,
        location: UPGRADE_PAGE,
        purchaseMotions: [TALK_TO_SALES],
        trackingSource: "HC0119-HeroBanner",
        upgradeData: upgradeData,
        use: "link",
        style: {
          height: 40,
          width: 315
        },
        _textOverride: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "interstitial.hc0119.talkToSales"
        })
      })]
    })]
  });
};
export default TrialUpgradePageMerchCard;